import { useState } from "react";
import { useErrorTabCount } from "src/Hooks/useErrorTabCount";
import { TabBox } from "src/Components";
import { ICCOrderSearchParams } from "src/Interfaces/ccOrder";
import { getCCOrderErrorTable } from "src/Requests/ccOrder";
import CCOrderTable from "src/Tables/CCOrder/Order/Table";
import CCTradeTable from "src/Tables/CCOrder/Trade/TradeTable";
import ErrorsTable from "src/Tables/Order/ErrorsTable/ErrorsTable";
import OrderBook from "./Orderbook/OrderBook";
import CCAggregateOrderTable from "src/Tables/CCOrder/Aggregate/Table";
import SearchParamBox from "./SearchParamBox";
import CheckBox from "src/Components/Checkbox";

export enum OrderTablesTabIndex {
  AggregationTable = 1,
  OrderTable,
  TradeTable,
  ErrorsTable,
}

const OrderResult = () => {
  const [tabIndex, setTabIndex] = useState(OrderTablesTabIndex.OrderTable);
  const [showDetails, setShowDetails] = useState(false);

  const [tablesSearchParam, setOrderTradeSearchParam] =
    useState<ICCOrderSearchParams>({} as ICCOrderSearchParams);

  const { errorTabCount, errorTableRefreshFlag, errorTableAfterFetchHandler } =
    useErrorTabCount(
      "ccOrder",
      tabIndex,
      OrderTablesTabIndex.ErrorsTable,
      getCCOrderErrorTable
    );

  const onTablesSearchParamChange = (name: string, value: any) => {
    setOrderTradeSearchParam({ ...tablesSearchParam, [name]: value });
  };

  const tablesTabsChildren = [
    { index: OrderTablesTabIndex.AggregationTable, title: "سفارشات تجمیعی" },
    { index: OrderTablesTabIndex.OrderTable, title: "سفارشات" },
    { index: OrderTablesTabIndex.TradeTable, title: "معاملات" },
    {
      index: OrderTablesTabIndex.ErrorsTable,
      title: "خطا",
      count: errorTabCount,
    },
  ];

  const getTabIndexTable = () => {
    switch (tabIndex) {
      case OrderTablesTabIndex.AggregationTable:
        return <CCAggregateOrderTable searchParam={tablesSearchParam} />;

      case OrderTablesTabIndex.OrderTable:
        return (
          <CCOrderTable
            searchParam={tablesSearchParam}
            showHiddenCols={showDetails}
          />
        );

      case OrderTablesTabIndex.TradeTable:
        return <CCTradeTable searchParam={tablesSearchParam} />;
      case OrderTablesTabIndex.ErrorsTable:
        return (
          <ErrorsTable
            getData={(searchParam, offset, pageSize) =>
              getCCOrderErrorTable(searchParam, offset, pageSize)
            }
            searchParams={tablesSearchParam}
            onFetchComplete={errorTableAfterFetchHandler}
            refreshFlag={errorTableRefreshFlag}
            tableBoxClassName="!max-h-[500px] overflow-auto"
          />
        );
    }
  };

  return (
    <div className="w-full flex flex-col gap-3">
      <OrderBook />
      <div className="w-full border-t-2 border-gray-300 mt-3 pt-5">
        <div className="max-w-min m-auto">
          <div className="w-full flex flex-row justify-between items-center gap-3">
            <div className="max-w-min">
              <TabBox
                activeTab={tabIndex}
                children={tablesTabsChildren}
                onChange={(_, index) => setTabIndex(index)}
              />
            </div>
            {tabIndex === OrderTablesTabIndex.OrderTable && (
              <CheckBox
                checked={showDetails}
                label="نمایش جزییات"
                name="showDetails"
                onChange={(_, checked) => setShowDetails(checked)}
              />
            )}
            <SearchParamBox
              onChange={onTablesSearchParamChange}
              searchParam={tablesSearchParam}
            />
          </div>
          <div className="w-full flex">{getTabIndexTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default OrderResult;
